export const WizardWidgetId = 'WizardWidget';

export enum WizardWidgetAttributes {
  PAGES = 'pages',
}
